import { render, staticRenderFns } from "./CreativityDetail.vue?vue&type=template&id=72ded1f0&"
import script from "./CreativityDetail.vue?vue&type=script&lang=ts&"
export * from "./CreativityDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports